import React, { useEffect, useState } from 'react';

import { useTranslation } from 'react-i18next';

import './_UndoAction.scss';

type Props = {
    onUndoClick: () => void;
    actionText: string;
    show: boolean;
};

export default function UndoAction({ onUndoClick, actionText, show }: Props) {
    const { t } = useTranslation('words');
    const [showAlert, setShowAlert] = useState<boolean>(false);
    useEffect(() => {
        if (show) {
            setShowAlert(show);
        }
    }, [show]);

    useEffect(() => {
        if (showAlert) {
            setTimeout(function () {
                setShowAlert(false);
            }, 5000);
        }
    }, [showAlert]);

    return (
        <div className={`UndoAction ${showAlert ? 'show' : 'hide'}`}>
            <p className="action-text">{actionText}</p>
            <div
                className="undo-btn"
                onClick={() => {
                    onUndoClick();
                    setShowAlert(false);
                }}
            >
                <p>{t('undo')}</p>
            </div>
        </div>
    );
}
